import { AbandonedCheckoutsRoute } from './stores/abandoned-checkout'
import { CouponsRoute } from './payments/coupons'
import { DashboardRoute } from './dashboard'
import { DocumentsContractsBuilderRoute } from './documents-contracts/documents-contracts-builder'
import { DocumentsContractsListRoute } from './documents-contracts/documents-contracts-list'
import { DocumentsContractsTemplateBuilderRoute } from './documents-contracts/documents-contracts-template-builder'
import { DocumentsContractsTemplateListRoute } from './documents-contracts/document-contracts-template-list'
import { FormBuilderRoutes } from './form-builder'
import { FunnelWebsiteRoute } from './funnel-websites'
import { InventoryRoute } from './products/inventory'
import { OrdersRoute } from './payments/orders'
import { PaymentIntegrationsRoute } from './payments/integrations'
import { PaymentsRoute } from './payments'
import { ProductRoute } from './products/products'
import { QuizBuilderRoutes } from './quiz'
import { SubscriptionsRoute } from './payments/subscriptions'
import { SurveyBuilderRoutes } from './survey-builder'
import { TransactionsRoute } from './payments/transactions'
import { aiEmployeePromoRoute } from './aiEmployeePromo'
import { analyticsRoute } from './analytics'
import { automationRoutes } from './automation'
import { blogsRoutes } from './blogs'
import { businessRoute } from './business'
import { calendarRoutes } from './calendars'
import { contactRoutes } from './contact'
import { contactsRoutes } from './contacts'
import { conversationRoute } from './conversations'
import { customMenuLinkRoute } from './customMenuLink'
import { customObjectsRoutes } from './customObjects'
import { customPageLinkRoute } from './customPageLink'
import { estimatesRoutes } from './payment-products/estimates'
import { integrationsRoute } from './integrations'
import { invoicesIntegrationsRoutes } from './payment-products/invoices-integrations'
import { invoicesRoutes } from './payment-products/invoices'
import { launchPadRoute } from './launchpad'
import { marketingRoute } from './marketing'
import { membershipRoutes } from './membership'
import { mobileAppRoute } from './mobileApp'
import { notificationsRoute } from './notifications'
import { opportunitiesRoute } from './opportunities'
import { paymentLinksRoutes } from './payment-products/payment-links'
import { paymentSetupRoute } from './paymentSetup'
import { remindersRoute } from './reminders'
import { reportingRoute } from './reporting'
import { reputationRoutes } from './reputation'
import { restrictedRoute } from './restricted'
import { seoRoute } from './seo'
import { socialMediaRoute } from './socialMedia'
import { suspendedRoute } from './suspended'
import { tasksRoute } from './tasks'
import { verificationRoute } from './verification'
import { copilotRoute } from './copilot'

export const locationRoutes = [
  ...launchPadRoute,
  ...DashboardRoute,
  ...calendarRoutes,
  ...conversationRoute,
  ...customObjectsRoutes,
  ...reportingRoute,
  ...automationRoutes,
  ...opportunitiesRoute,
  ...membershipRoutes,
  ...contactsRoutes,
  ...contactRoutes,
  ...integrationsRoute,
  ...reputationRoutes,
  ...FunnelWebsiteRoute,
  ...marketingRoute,
  ...FormBuilderRoutes,
  ...SurveyBuilderRoutes,
  ...QuizBuilderRoutes,
  ...remindersRoute,
  ...socialMediaRoute,
  ...notificationsRoute,
  ...verificationRoute,
  ...suspendedRoute,
  ...restrictedRoute,
  ...blogsRoutes,
  ...tasksRoute,
  ...businessRoute,
  ...customPageLinkRoute,
  ...customMenuLinkRoute,
  ...mobileAppRoute,
  ...analyticsRoute,
  ...aiEmployeePromoRoute,
  ...paymentSetupRoute,
  ...seoRoute,
  ...PaymentsRoute,
  ...TransactionsRoute,
  ...SubscriptionsRoute,
  ...CouponsRoute,
  ...OrdersRoute,
  ...PaymentIntegrationsRoute,
  ...paymentLinksRoutes,
  ...invoicesIntegrationsRoutes,
  ...estimatesRoutes,
  ...invoicesRoutes,
  ...DocumentsContractsListRoute,
  ...DocumentsContractsTemplateListRoute,
  ...DocumentsContractsBuilderRoute,
  ...DocumentsContractsTemplateBuilderRoute,
  ...ProductRoute,
  ...InventoryRoute,
  ...AbandonedCheckoutsRoute,
  ...copilotRoute,
]
